import script from "./PortalHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalHomePage.vue?vue&type=script&setup=true&lang=js"

import "./PortalHomePage.vue?vue&type=style&index=0&id=35d3d1a4&lang=scss"
import "./PortalHomePage.vue?vue&type=style&index=1&id=35d3d1a4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d3d1a4"]])

export default __exports__